import React from 'react';
import { InventoryStatus, ReserveStatus } from '../../../types';
import { Offer } from '../../../ContentfulTypes';
import CarrierOffer from './CarrierOffer/CarrierOffer';

interface Props {
  availableOffers: Array<Offer>;
  variantLabels: Record<string, string>;
  clickHandler: (offer: Offer) => void;
  selectedCarrier?: string;
  ariaLabel: string;
  reserveStatus: ReserveStatus;
}
const CarrierOffers = ({
  availableOffers,
  variantLabels,
  clickHandler,
  selectedCarrier,
  ariaLabel,
  reserveStatus,
}: Props) => {
  let offers = availableOffers;
  if (reserveStatus === ReserveStatus.InventoryBased) {
    offers = offers.filter(
      ({ status }) => status !== InventoryStatus.OutOfStock,
    );
  }
  return (
    <>
      {offers.map((offer) => (
        <CarrierOffer
          offer={offer}
          labels={variantLabels}
          key={offer.phoneCarrier.cmsName}
          clickHandler={clickHandler}
          selectedCarrier={selectedCarrier}
          ariaLabel={ariaLabel}
        />
      ))}
    </>
  );
};

export default CarrierOffers;
